module.exports = __webpack_public_path__ + "static/media/backgroundImage.c5d3d77b.jpg";